<template>
  <div v-if="extData.tenderTermsId">
    <HkldDropzone
      v-if="allowEdit"
      :sourceId="extData.tenderTermsId"
      :action="ActionTypes.settings.doc.tender.create"
      :metaData="{uploadOnTop: true}"
    />
    <EditTerms
      :sourceId="extData.tenderTermsId"
      :canEdit="allowEdit"
      :canDelete="allowEdit"
      :canDownloadAll="false"
      :action="ActionTypes.settings.doc.tender.delete"
      :updateAction="ActionTypes.settings.doc.tender.edited"
    />
  </div>
</template>
<script>
import HkldDropzone from '@/controls/HkldDropzone'
import EditTerms from '@/controls/EditTerms'
import { ActionTypes } from '@/utils/consts'

export default {
  name: 'Tender',
  components: {
    HkldDropzone, EditTerms,
  },
  model: {
    prop: 'extData',
    event: 'onChange',
  },
  props: {
    event: Object,
    extData: Object,
    formOptions: Object,
  },
  data () {
    return {
      ActionTypes,
    }
  },
  computed: {
    allowEdit () {
      const { formOptions: options } = this
      return !options.readonly && (
        options.isAdmin ||
        options.hasSettingUpdateAccess ||
        options.hasDocuementUpdateAccess
      )
    },
  },
}
</script>
<style scoped lang="scss">
</style>
